import { Model } from '@vuex-orm/core'

export class LessonBookable extends Model {
  static entity = 'lessonBookable'
  static primaryKey = ['lesson_id', 'bookable_id']

  static fields () {
    return {
      lesson_id: this.attr(null),
      bookable_id: this.attr(null)
    }
  }
}

export default LessonBookable
